export default __webpack_public_path__ + "navigation-overview-quickstart-result-1200-10596988d3d1bbd67c0780fc7cef8a32.png";